import React from "react";
import Linechart from "../../components/Graph/Linechart";
import { Information, CalendarHeatMap, ChevronDown } from "@carbon/icons-react";
import moment from "moment";
import UIkit from "uikit";
// import Calendar from "../../components/common/Calender";
import Calendar from "../../components/common/Calendar";
import { url } from "../../Constant";
import axios from "axios";
import { useEffect } from "react";

import { useState } from "react";
import { useAuth } from "../../Context/AuthProvider";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";

const Dashboard = () => {
  const [summary, setSummary] = useState();

  // for indiviual api summary
  const [usageSummary, setUsageSummary] = useState();
  const [summaryHighlight, setSummaryHighlight] = useState();
  const [inboundCalls, setInboundCalls] = useState();
  const [outboundCalls, setOutboundCalls] = useState();
  const [feedbackCalls, setFeedbackCalls] = useState();

  // for indiviual api summary end

  const [loader, setLoader] = useState(false);
  const [topAgent, setTopAgent] = useState({
    inbound: null,
    outbound: null,
  });
  const [isSearched, setIsSearched] = useState(false);
  // const [STARTDATE, setSTARTDATE] = useState(
  //   moment().startOf("month").format("YYYY-MM-DD")
  // );
  // const [ENDDATE, setENDDATE] = useState(
  //   moment().endOf("month").format("YYYY-MM-DD")
  // );
  const [extensionNumber, setExtensionNumber] = useState("");
  const [STARTDATE, setSTARTDATE] = useState("");
  const [ENDDATE, setENDDATE] = useState("");
  const [graphDataAdmin, setGraphDataAdmin] = useState();
  const [extensionList, setExtensionList] = useState();
  const { auth } = useAuth();

  // useEffect(() => {
  //   getHighlight();
  //   getGraphForAdmin();
  // }, [STARTDATE, ENDDATE]);

  const getExtensions = () => {
    if (auth.role === "2") {
      axios
        .post(
          url + "get-all-extensions",
          {
            vpbx_id: auth.vpbx_id,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "Data Found") {
                setExtensionList(response.data.data);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else if (auth.role === "3") {
      axios
        .post(
          url + "user-get-all-extensions",
          {
            vpbx_id: auth.vpbx_id,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "Data Found") {
                setExtensionList(response.data.data);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  // umair code start

  const getSummaryfetchData = (endpoint) => {
    axios
      .post(
        endpoint,
        {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            setSummary(response.data.data);
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getUsageSummary = (endpoint) => {
    axios
      .post(
        endpoint,
        {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            setUsageSummary(response.data.data);
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getSummaryHighlight = (endpoint) => {
    axios
      .post(
        endpoint,
        {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            setSummaryHighlight(response.data.data);
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getInboundCalls = (endpoint) => {
    axios
      .post(
        endpoint,
        {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            setInboundCalls(response.data.data);
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getOutboundCalls = (endpoint) => {
    axios
      .post(
        endpoint,
        {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            setOutboundCalls(response.data.data);
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getFeedbackCalls = (endpoint) => {
    axios
      .post(
        endpoint,
        {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            setFeedbackCalls(response.data.data);
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  let getSummary;

  if (auth.role === "2") {
    if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
      // getSummary = () =>
      //   getSummaryfetchData(url + "postx_vpbx_manager_dashboard");
      getSummary = () => {
        getUsageSummary(url + "postx_vpbx_manager_usageSummary");
        getSummaryHighlight(url + "postx_vpbx_manager_highlight");
        getInboundCalls(url + "postx_vpbx_manager_inboundCalls");
        getOutboundCalls(url + "postx_vpbx_manager_outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "postx_vpbx_manager_feedbackCalls");
        }
      };
    } else if (auth.vpbx_id === process.env.REACT_APP_TRAVEL) {
      // getSummary = () =>
      //   getSummaryfetchData(url + "postx_vpbx_manager_dashboard");
      getSummary = () => {
        getUsageSummary(url + "travel-channel-usageSummary");
        getSummaryHighlight(url + "travel-channel-highlights");
        getInboundCalls(url + "travel-channel-inboundCalls");
        getOutboundCalls(url + "travel-channel-outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "travel-channel-feedbackCalls");
        }
      };
    } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
      // getSummary = () =>
      //   getSummaryfetchData(url + "leopard_vpbx_manager_dashboard");
      getSummary = () => {
        getUsageSummary(url + "leopard_vpbx_manager_usageSummary");
        getSummaryHighlight(url + "leopard_vpbx_manager_highlight");
        getInboundCalls(url + "leopard_vpbx_manager_inboundCalls");
        getOutboundCalls(url + "leopard_vpbx_manager_outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "leopard_vpbx_manager_feedbackCalls");
        }
      };
    } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
      // getSummary = () =>
      //   getSummaryfetchData(url + "tcs_vpbx_manager_dashboard");
      getSummary = () => {
        getUsageSummary(url + "tcs_vpbx_manager_usageSummary");
        getSummaryHighlight(url + "tcs_vpbx_manager_highlight");
        getInboundCalls(url + "tcs_vpbx_manager_inboundCalls");
        getOutboundCalls(url + "tcs_vpbx_manager_outboundCalls");
        getFeedbackCalls(url + "tcs_vpbx_manager_feedbackCalls");
      };
    } else {
      // getSummary = () =>
      //   getSummaryfetchData(url + "company_vpbx_manager_dashboard");
      getSummary = () => {
        getUsageSummary(url + "company_vpbx_manager_usageSummary");
        getSummaryHighlight(url + "company_vpbx_manager_highlight");
        getInboundCalls(url + "company_vpbx_manager_inboundCalls");
        getOutboundCalls(url + "company_vpbx_manager_outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "company_vpbx_manager_feedbackCalls");
        }
      };
    }
  } else if (auth.role === "3") {
    if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
      // getSummary = () =>
      //   getSummaryfetchData(url + "user-postx_vpbx_manager_dashboard");
      getSummary = () => {
        getUsageSummary(url + "user-postx_vpbx_manager_usageSummary");
        getSummaryHighlight(url + "user-postx_vpbx_manager_highlight");
        getInboundCalls(url + "user-postx_vpbx_manager_inboundCalls");
        getOutboundCalls(url + "user-postx_vpbx_manager_outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "user-postx_vpbx_manager_feedbackCalls");
        }
      };
    } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
      // getSummary = () =>
      //   getSummaryfetchData(url + "user-leopard_vpbx_manager_dashboard");

      getSummary = () => {
        getUsageSummary(url + "user-leopard_vpbx_manager_usageSummary");
        getSummaryHighlight(url + "user-leopard_vpbx_manager_highlight");
        getInboundCalls(url + "user-leopard_vpbx_manager_inboundCalls");
        getOutboundCalls(url + "user-leopard_vpbx_manager_outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "user-leopard_vpbx_manager_feedbackCalls");
        }
      };
    } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
      // getSummary = () =>
      //   getSummaryfetchData(url + "user-tcs_vpbx_manager_dashboard");

      getSummary = () => {
        getUsageSummary(url + "user-tcs_vpbx_manager_usageSummary");
        getSummaryHighlight(url + "user-tcs_vpbx_manager_highlight");
        getInboundCalls(url + "user-tcs_vpbx_manager_inboundCalls");
        getOutboundCalls(url + "user-tcs_vpbx_manager_outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "user-tcs_vpbx_manager_feedbackCalls");
        }
      };
    } else {
      // getSummary = () =>
      //   getSummaryfetchData(url + "user_vpbx_manager_dashboard");
      getSummary = () => {
        getUsageSummary(url + "user-vpbx_manager_usageSummary");
        getSummaryHighlight(url + "user-vpbx_manager_highlight");
        getInboundCalls(url + "user-vpbx_manager_inboundCalls");
        getOutboundCalls(url + "user-vpbx_manager_outboundCalls");
        if (auth.call_initiated === "1") {
          getFeedbackCalls(url + "user-vpbx_manager_feedbackCalls");
        }
      };
    }
  }

  const getHighlight = () => {
    if (auth.role === "1") {
      axios
        .post(
          url + "admin-dashboard",
          {
            vpbx_id: null,
            start_date: STARTDATE,
            end_date: ENDDATE,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "Data Found") {
                setSummary(response.data.data);
                setLoader(false);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  // umair code start
  const TopAgentfetchData = (endpoint) => {
    axios
      .post(
        endpoint,
        {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            let inboundData = [];
            let outboundData = [];
            response.data.data.forEach((val) => {
              inboundData.push(val.inbound);
              outboundData.push(val.outbound);
            });
            setTopAgent({
              inbound: inboundData,
              outbound: outboundData,
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  let getTopAgent;
  if (auth.role === "2") {
    if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
      getTopAgent = () => TopAgentfetchData(url + "postex-top-agents");
    } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
      getTopAgent = () => TopAgentfetchData(url + "leopard-top-agents");
    } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
      getTopAgent = () => TopAgentfetchData(url + "tcs-top-agents");
    } else if (auth.vpbx_id === process.env.REACT_APP_TRAVEL) {
      getTopAgent = () => TopAgentfetchData(url + "travel-channel-topAgent");
    } else {
      getTopAgent = () => TopAgentfetchData(url + "company_vpbx_top_agent");
    }
  } else if (auth.role === "3") {
    if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
      getTopAgent = () => TopAgentfetchData(url + "user-postex-top-agents");
    } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
      getTopAgent = () => TopAgentfetchData(url + "user-leopard-top-agents");
    } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
      getTopAgent = () => TopAgentfetchData(url + "user-tcs-top-agents");
    } else if (auth.vpbx_id === process.env.REACT_APP_TRAVEL) {
      getTopAgent = () =>
        TopAgentfetchData(url + "user-travel-channel-topAgent");
    } else {
      getTopAgent = () => TopAgentfetchData(url + "user_vpbx_top_agent");
    }
  }
  // umair code end

  // const getVPBXUser = () => {
  //   if (auth.role === "3") {
  //     axios
  //       .post(
  //         url + "vpbx-users-dashboard",
  //         {
  //           sip_id: auth.defaultuser,
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${auth.token}`,
  //           },
  //         }
  //       )
  //       .then(
  //         (response) => {
  //           if (response.status === 200) {
  //             if (response.data.message === "Data Found") {
  //               setSummary(response.data.data);
  //             }
  //           }
  //         },
  //         (error) => {
  //           console.log(error);
  //         }
  //       );
  //   }
  // };

  // let getGraphForAdmin;
  // if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
  //   getGraphForAdmin = () => {
  //     if (auth.role === "2") {
  //       axios
  //         .post(
  //           url + "postex-graph-details",
  //           {
  //             vpbx_id: auth.vpbx_id,
  //             start_date: STARTDATE,
  //             end_date: ENDDATE,
  //             extension_number: extensionNumber,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${auth.token}`,
  //             },
  //           }
  //         )
  //         .then(
  //           (response) => {
  //             if (response.status === 200) {
  //               if (response.data.message === "Data Found") {
  //                 setGraphDataAdmin(response.data.data);
  //               }
  //             }
  //           },
  //           (error) => {
  //             console.log(error);
  //           }
  //         );
  //     }
  //     if (auth.role === "1") {
  //       axios
  //         .post(
  //           url + "graph_details",
  //           {
  //             vpbx_id: auth.vpbx_id,
  //             start_date: STARTDATE,
  //             end_date: ENDDATE,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${auth.token}`,
  //             },
  //           }
  //         )
  //         .then(
  //           (response) => {
  //             if (response.status === 200) {
  //               if (response.data.message === "Data Found") {
  //                 setGraphDataAdmin(response.data.data);
  //               }
  //             }
  //           },
  //           (error) => {
  //             console.log(error);
  //           }
  //         );
  //     }
  //   };
  // } else {
  //   getGraphForAdmin = () => {
  //     if (auth.role === "2") {
  //       axios
  //         .post(
  //           url + "company_graph_details",
  //           {
  //             vpbx_id: auth.vpbx_id,
  //             start_date: STARTDATE,
  //             end_date: ENDDATE,
  //             extension_number: extensionNumber,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${auth.token}`,
  //             },
  //           }
  //         )
  //         .then(
  //           (response) => {
  //             if (response.status === 200) {
  //               if (response.data.message === "Data Found") {
  //                 setGraphDataAdmin(response.data.data);
  //               }
  //             }
  //           },
  //           (error) => {
  //             console.log(error);
  //           }
  //         );
  //     }
  //     if (auth.role === "1") {
  //       axios
  //         .post(
  //           url + "graph_details",
  //           {
  //             vpbx_id: auth.vpbx_id,
  //             start_date: STARTDATE,
  //             end_date: ENDDATE,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${auth.token}`,
  //             },
  //           }
  //         )
  //         .then(
  //           (response) => {
  //             if (response.status === 200) {
  //               if (response.data.message === "Data Found") {
  //                 setGraphDataAdmin(response.data.data);
  //               }
  //             }
  //           },
  //           (error) => {
  //             console.log(error);
  //           }
  //         );
  //     }
  //   };
  // }

  // umair code start
  const getGraphForAdminfetchData = (endpoint, data) => {
    axios
      .post(endpoint, data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (
            response.status === 200 &&
            response.data.message === "Data Found"
          ) {
            setGraphDataAdmin(response.data.data);
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  let getGraphForAdmin;
  if (auth.role === "2") {
    if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "postex-graph-details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "leopard-graph-details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "tcs-graph-details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    } else if (auth.vpbx_id === process.env.REACT_APP_TRAVEL) {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "travel-channel-graphDetails", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    } else {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "company_graph_details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    }
  } else if (auth.role === "1") {
    getGraphForAdmin = () =>
      getGraphForAdminfetchData(url + "graph_details", {
        vpbx_id: auth.vpbx_id,
        start_date: STARTDATE,
        end_date: ENDDATE,
      });
  } else if (auth.role === "3") {
    if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "user-postex-graph-details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "user-leopard-graph-details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "user-tcs-graph-details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    } else {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "user_graph_details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
          extension_number: extensionNumber,
        });
    }
  }
  // umair code end

  const getGraphForUser = () => {
    if (auth.role === "3") {
      axios
        .post(
          url + "vpbx-users-graph",
          {
            sip_id: auth.defaultuser,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "Data Found") {
                setGraphDataAdmin(response.data.data);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };


  // Musfer ~~~~

  const GetDashboardData = () => {





    axios
      .post(
        url + "vpbx-dashboard-data",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (response.data.message === "Data Found") {
              setSummaryHighlight(response.data.data.highlightsStates);
              setUsageSummary(response.data.data.usageSummaryStates);
              setInboundCalls(response.data.data.inboundCallStates);
              setOutboundCalls(response.data.data.outboundCallStates)

              if ( auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX && auth.call_initiated === "1") {
                getFeedbackCalls(url + "postx_vpbx_manager_feedbackCalls");
              }
              
              if ( auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX && auth.call_initiated === "1") {
                getFeedbackCalls(url + "leopard_vpbx_manager_feedbackCalls");
              }
              
              if ( auth.vpbx_id === process.env.REACT_APP_TCS_VPBX && auth.call_initiated === "1") {
                getFeedbackCalls(url + "tcs_vpbx_manager_feedbackCalls");
              }
              
              if ( auth.vpbx_id === process.env.REACT_APP_TRAVEL && auth.call_initiated === "1") {
                getFeedbackCalls(url + "travel-channel-feedbackCalls");
              }

            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  // Musfer ~~~~ //










  useEffect(() => {


    // if login from 4 Accounts (tcs,postex,leopard,travel)
    // then dashboard data fetches from GetDashboardData();
    // else there is a different api for every card

    if ((auth.vpbx_id === process.env.REACT_APP_TCS_VPBX ||
      auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX ||
      auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX ||
      auth.vpbx_id === process.env.REACT_APP_TRAVEL) && auth.role === "2") {
      GetDashboardData(); 
    }
    
    
    
    else {      
      if (auth.role === "3") {
        if (!checkPermissions("dashboard")) {
          window.location.href = "/";
        }
      }
  
      getExtensions();
      getHighlight();
      getGraphForAdmin();
  
      if (auth.role === "2" || auth.role === "3") {
        getSummary();
        // getTopAgent();
      }
    }





  }, [STARTDATE, ENDDATE]);

  const handleDatePickerClose = () => {
    UIkit.drop("#datepickerdrop").hide(true);
  };

  const onChange = (ranges) => {
    console.log("admin", 1111);
    let startDate = moment(ranges.startDate).format("YYYY-MM-DD");
    let endDate = moment(ranges.endDate).format("YYYY-MM-DD");
    setSTARTDATE(startDate);
    setENDDATE(endDate);
  };

  const searchhandleClick = () => {
    setLoader(true);
    getSummary();
    getGraphForAdmin();
    getHighlight();
    // getTopAgent();
    // You might want to handle loader state after all functions are executed
  };

  return (
    <>
      {/* for super admin only  */}
      {auth.role === "1" && (
        <div className="dashboardWrp">
          <div className="uk-container uk-container-large">
            <div className="dashboardTop">
              <div uk-grid="" className="uk-grid uk-grid-small">
                <div className="uk-width-1-2">
                  <div className="dashboardIntro">
                    <h3>DASHBOARDS</h3>
                  </div>
                </div>
                <div className="uk-width-1-2">
                  <div className="uk-text-right">
                    <span>
                      <div className="uk-inline uk-text-left">
                        <button
                          className="uk-button date-filter-button uk-padding-remove"
                          type="button"
                        >
                          <CalendarHeatMap />
                          {STARTDATE === "" && ENDDATE === "" && (
                            <span>select data</span>
                          )}
                          {STARTDATE !== "" && ENDDATE !== "" && (
                            <span>
                              {moment(STARTDATE).format("Do MMMM YYYY")} -{" "}
                              {moment(ENDDATE).format("Do MMMM YYYY")}
                            </span>
                          )}

                          <ChevronDown />
                        </button>
                        <div
                          id="datepickerdrop"
                          uk-drop="mode: click;animation: uk-animation-slide-top-small; animate-out: true"
                          className="date-picker-container"
                        >
                          <Calendar onChange={onChange} />
                          <div className="date-picker-btn-container uk-text-right">
                            <button
                              className="date-selection-btn"
                              onClick={handleDatePickerClose}
                            >
                              Ok
                            </button>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span className="primary-color"></span>
                  </div>
                </div>
              </div>
            </div>
            <div
              uk-grid=""
              uk-height-match="target: div > .uk-card"
              className="uk-grid uk-grid-small"
            >
              {/* Highlights */}
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Highlights</h5>
                  </div>
                  <div className="uk-container uk-container-small">
                    <div uk-grid="">
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.vpbx_details === null ? (
                              0
                            ) : (
                              summary?.vpbx_details
                            )}
                          </h3>
                          <p>Registered VPBX </p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.diod_details === null ? (
                              0
                            ) : (
                              summary?.diod_details
                            )}
                          </h3>
                          <p>Available Master Number</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_call_count === null ? (
                              0
                            ) : (
                              summary?.inbound_call_count
                            )}
                          </h3>
                          <p>Total Inbound Calls</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_call_count === null ? (
                              0
                            ) : (
                              summary?.outbound_call_count
                            )}
                          </h3>
                          <p>Total Outbound Calls</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* highlight end */}
              {/* Call Overview */}
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5>Call Overview</h5>
                  </div>
                  {/* Chart */}
                  <div className="ChannelsOverviewGraph">
                    <Linechart
                      labels={graphDataAdmin?.labels}
                      data1={graphDataAdmin?.inbound}
                      data2={graphDataAdmin?.outound}
                      name1="Inbound calls"
                      name2="Outbound Calls"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* for admin only  */}
      {(auth.role === "2" || auth.role === "3") && (
        <div className="dashboardWrp">
          <div className="uk-container uk-container-large">
            <div className="dashboardTop">
              <div uk-grid="" className="uk-grid uk-grid-small">
                <div className="uk-width-1-2">
                  <div className="dashboardIntro">
                    <h3>
                      DASHBOARDS{" "}
                      <span className="companyName">
                        ({/* Extesnion : */}
                        {auth.company_name === null
                          ? " not availble "
                          : auth.company_name}
                        )
                      </span>
                    </h3>
                    <h4></h4>
                  </div>
                </div>



                <div className="uk-width-1-2">
                  <div className=" uk-text-right">
                    {isSearched === false ? (
                      (auth.role === "2" ||
                        checkIndividualPermission(
                          "dashboard",
                          "read_and_write"
                        )) && (
                        <button
                          className="exportData-button"
                          onClick={() => setIsSearched(true)}
                        >
                          Add Filter
                        </button>
                      )
                    ) : (
                      <button
                        className="exportData-button"
                        onClick={() => setIsSearched(false)}
                      >
                        Close Filter
                      </button>
                    )}
                  </div>
                  {/* <div className="uk-text-right">
                    <span>
                      <div className="uk-inline uk-text-left">
                        <button
                          className="uk-button date-filter-button uk-padding-remove"
                          type="button"
                        >
                          <CalendarHeatMap />
                          {STARTDATE === "" && ENDDATE === "" && (
                            <span>select data</span>
                          )}
                          {STARTDATE !== "" && ENDDATE !== "" && (
                            <span>
                              {moment(STARTDATE).format("Do MMMM YYYY")} -{" "}
                              {moment(ENDDATE).format("Do MMMM YYYY")}
                            </span>
                          )}

                          <ChevronDown />
                        </button>
                        <div
                          id="datepickerdrop"
                          uk-drop="mode: click;animation: uk-animation-slide-top-small; animate-out: true"
                          className="date-picker-container"
                        >
                          <Calendar onChange={onChange} />
                          <div className="date-picker-btn-container uk-text-right">
                            <button
                              className="date-selection-btn"
                              onClick={handleDatePickerClose}
                            >
                              Ok
                            </button>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span className="primary-color"></span>
                  </div> */}
                </div>
              </div>
              {isSearched === true && (
                <div className="uk-flex uk-flex-between uk-margin-top">
                  <div>
                    <div className="dashboardIntro">
                      <h3>
                        <span className="companyName">Filter</span>
                      </h3>
                    </div>
                  </div>
                  <div>
                    <div className="uk-flex uk-flex-between">
                      <div className="uk-flex uk-flex-between">
                        <div style={{ margin: "10px" }}>
                          <label>Start Date</label>
                        </div>
                        <div>
                          <input
                            type="date"
                            className="uk-input"
                            onChange={(e) => {
                              let date = e.target.value;
                              setSTARTDATE(moment(date).format("YYYY-MM-DD"));
                            }}
                          />
                        </div>
                      </div>
                      <div className="uk-flex uk-flex-between">
                        <div style={{ margin: "10px" }}>
                          <label> End Date </label>
                        </div>
                        <div>
                          <input
                            type="date"
                            className="uk-input"
                            onChange={(e) => {
                              let date = e.target.value;
                              setENDDATE(moment(date).format("YYYY-MM-DD"));
                            }}
                          />
                        </div>
                      </div>
                      <div className="uk-flex uk-flex-between">
                        <div style={{ margin: "10px" }}>
                          <label> Extension </label>
                        </div>
                        <div>
                          <select
                            name="type"
                            onChange={(e) => {
                              setExtensionNumber(e.target.value);
                            }}
                            className="uk-select"
                          >
                            <option value="" selected disabled>
                              please select Extension type
                            </option>
                            {extensionList?.map((val, index) => {
                              return (
                                <option key={index} value={val}>
                                  {val}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      {/* <div>
                        <button
                          className="exportData-button"
                          onClick={() => {
                            setSTARTDATE("");
                            setENDDATE("");
                            setExtensionNumber("");
                            getSummary();
                            getGraphForAdmin();
                            getHighlight();
                          }}
                        >
                          Clear Filter
                        </button>
                      </div> */}
                      <div>
                        <button
                          className="exportData-button"
                          onClick={searchhandleClick}
                        >
                          {loader ? (
                            <div uk-spinner="" className="loader">
                              {/* Searching  */}
                            </div>
                          ) : (
                            "Search"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
            </div>
            <div
              uk-grid=""
              uk-height-match="target: div > .uk-card"
              className="uk-grid uk-grid-small"
            >
              {/* Highlights */}
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Highlights</h5>
                  </div>
                  <div className="uk-container uk-container-small">
                    <div uk-grid="">
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.highlights?.total_calls === null ? (
                              0
                            ) : (
                              summary?.highlights?.total_calls
                            )} */}
                            {summaryHighlight === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summaryHighlight?.total_calls === null ? (
                              0
                            ) : (
                              summaryHighlight?.total_calls
                            )}
                          </h3>
                          <p>
                            <span className="dashTextItem">
                              <img
                                src="./assets/images/zong/phone.svg"
                                uk-svg=""
                              />
                            </span>
                            Total Calls
                          </p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.highlights?.call_back === null ? (
                              0
                            ) : (
                              summary?.highlights?.call_back
                            )} */}
                            {summaryHighlight === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summaryHighlight?.call_back === null ? (
                              0
                            ) : (
                              summaryHighlight?.call_back
                            )}
                          </h3>
                          <p>
                            <span className="dashTextItem">
                              <img
                                src="./assets/images/zong/phone--outgoing.svg"
                                uk-svg=""
                              />
                            </span>
                            Callback
                          </p>
                        </div>
                      </div>
                      {/* <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.highlights?.never_callback === null ? (
                              0
                            ) : (
                              summary?.highlights?.never_callback
                            )}
                          </h3>
                          <p>
                            <span className="dashTextItem">
                              <img
                                src="./assets/images/zong/phone--off.svg"
                                uk-svg=""
                              />
                            </span>
                            Never callback
                          </p>
                        </div>
                      </div> */}
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.highlights?.avg_callback_time ===
                              null ? (
                              0
                            ) : (
                              summary?.highlights?.avg_callback_time
                            )} */}
                            {summaryHighlight === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summaryHighlight?.avg_callback_time === null ? (
                              0
                            ) : (
                              summaryHighlight?.avg_callback_time
                            )}
                          </h3>
                          <p>
                            <span className="dashTextItem">
                              <img
                                src="./assets/images/zong/hourglass.svg"
                                uk-svg=""
                              />
                            </span>
                            Avg. Callback Time
                          </p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.total_extension === null ? (
                              0
                            ) : (
                              summary?.total_extension
                            )} */}
                            {summaryHighlight === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summaryHighlight?.total_extension === null ? (
                              0
                            ) : (
                              summaryHighlight?.total_extension
                            )}
                          </h3>
                          <p>
                            <span className="dashTextItem">
                              <img
                                src="./assets/images/zong/hourglass.svg"
                                uk-svg=""
                              />
                            </span>
                            Total Extensions
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* highlight end */}

              {/* usage summary start */}
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Usage summary</h5>
                  </div>
                  <div className="uk-container uk-container-small">
                    <div uk-grid="">
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.uesage_summary?.inbound_minutes ===
                              null ? (
                              0
                            ) : (
                              summary?.uesage_summary?.inbound_minutes
                            )} */}
                            {usageSummary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : usageSummary?.inbound_minutes === null ? (
                              0
                            ) : (
                              usageSummary?.inbound_minutes
                            )}
                          </h3>
                          <p>Inbound Minutes</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.uesage_summary?.consumed_minutes ===
                              null ? (
                              0
                            ) : (
                              summary?.uesage_summary?.consumed_minutes
                            )} */}
                            {usageSummary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : usageSummary?.consumed_minutes === null ? (
                              0
                            ) : (
                              usageSummary?.consumed_minutes
                            )}
                          </h3>
                          <p>Consumed Minutes</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.uesage_summary?.outbound_minutes ===
                              null ? (
                              0
                            ) : (
                              summary?.uesage_summary?.outbound_minutes
                            )} */}
                            {usageSummary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : usageSummary?.outbound_minutes === null ? (
                              0
                            ) : (
                              usageSummary?.outbound_minutes
                            )}
                          </h3>
                          <p>Outbound Minutes</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.uesage_summary?.register_extentions ===
                              null ? (
                              0
                            ) : (
                              summary?.uesage_summary?.register_extentions
                            )} */}
                            {usageSummary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : usageSummary?.register_extentions === null ? (
                              0
                            ) : (
                              usageSummary?.register_extentions
                            )}
                          </h3>
                          <p>Registered Extensions</p>
                        </div>
                      </div>
                      {/* <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.uesage_summary?.conference_details ===
                              null ? (
                              0
                            ) : (
                              summary?.uesage_summary?.conference_details
                            )}
                          </h3>
                          <p>Conference</p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* usage summary end */}
              {/* Campaign Overview */}
              {/* <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body CampaignOverview">
                  <div className="head">
                    <h5>Campaign Overview</h5>
                  </div>
                  <div className="ChannelsOverviewGraph">
                    <Linechart
                      labels={graphDataAdmin?.labels}
                      data1={graphDataAdmin?.inbound}
                      data2={graphDataAdmin?.outound}
                      name1="Inbound calls"
                      name2="Outbound Calls"
                    />
                  </div>
                </div>
              </div> */}

              {/* Incoming Calls start */}
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Incoming calls</h5>
                  </div>
                  <div className="uk-container uk-container-small customfonthead">
                    <div className="uk-grid uk-grid-small" uk-grid="">
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          {/* <h3>23</h3> */}
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.total_talk_time ===
                              null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.total_talk_time
                            )} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.total_talk_time === null ? (
                              0
                            ) : (
                              inboundCalls?.total_talk_time
                            )}
                          </h3>
                          <p>Total Talk Time</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.total_incoming_calls ===
                              null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.total_incoming_calls
                            )} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.total_incoming_calls === null ? (
                              0
                            ) : (
                              inboundCalls?.total_incoming_calls
                            )}
                          </h3>
                          <p>Total Inbound Calls</p>
                        </div>
                      </div>

                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.missed === null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.missed
                            )} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.missed === null ? (
                              0
                            ) : (
                              inboundCalls?.missed
                            )}
                          </h3>
                          <p>Total Missed </p>
                        </div>
                      </div>

                      {/* <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {summary?.inbound_calls?.total_incoming_calls ===
                            null
                              ? 0
                              : summary?.inbound_calls?.total_incoming_calls}
                          </h3>
                          <p>Total incoming</p>
                        </div>
                      </div> */}
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.uniqe_inbound_calls ===
                              null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.uniqe_inbound_calls
                            )} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.uniqe_inbound_calls === null ? (
                              0
                            ) : (
                              inboundCalls?.uniqe_inbound_calls
                            )}
                          </h3>
                          <p>Total Unique</p>
                        </div>
                      </div>

                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.unique_missed ===
                              null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.unique_missed
                            )} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.unique_missed === null ? (
                              0
                            ) : (
                              inboundCalls?.unique_missed
                            )}
                          </h3>
                          <p>Total Unique Missed</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.unique_answered ===
                              null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.unique_answered
                            )} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.unique_answered === null ? (
                              0
                            ) : (
                              inboundCalls?.unique_answered
                            )}
                          </h3>
                          <p>Unique Answered</p>
                        </div>
                      </div>

                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.answered === null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.answered
                            )}
                            {summary !== undefined && "%"} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.answered === null ? (
                              0
                            ) : (
                              inboundCalls?.answered
                            )}
                            {inboundCalls !== undefined && "%"}
                          </h3>
                          <p>Answered %</p>
                        </div>
                      </div>

                      {/* <div className="uk-width-expand">
                      <div className="overCardTxt">
                        <h3>23%</h3>
                        <p>Connected</p>
                      </div>
                    </div> */}

                      {/* <div className="uk-width-expand">
                      <div className="overCardTxt">
                        <h3>0</h3>
                        <p>Unique connected</p>
                      </div>
                    </div> */}

                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.inbound_calls?.call_back === null ? (
                              0
                            ) : (
                              summary?.inbound_calls?.call_back
                            )} */}
                            {inboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : inboundCalls?.call_back === null ? (
                              0
                            ) : (
                              inboundCalls?.call_back
                            )}
                          </h3>
                          <p>Callback</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Outging calls start */}
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Outgoing calls</h5>
                  </div>
                  <div className="uk-container uk-container-small">
                    <div className="uk-grid uk-grid-small" uk-grid="">
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_calls?.total_talk_time ===
                              null ? (
                              0
                            ) : (
                              summary?.outbound_calls?.total_talk_time
                            )} */}
                            {outboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : outboundCalls?.total_talk_time === null ? (
                              0
                            ) : (
                              outboundCalls?.total_talk_time
                            )}
                          </h3>
                          <p>Total Talk Time</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_calls
                                ?.total_outgoing_calls === null ? (
                              0
                            ) : (
                              summary?.outbound_calls?.total_outgoing_calls
                            )} */}
                            {outboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : outboundCalls?.total_outgoing_calls === null ? (
                              0
                            ) : (
                              outboundCalls?.total_outgoing_calls
                            )}
                          </h3>
                          <p>Total Outgoing Calls</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_calls
                                ?.uniqe_outgoing_calls === null ? (
                              0
                            ) : (
                              summary?.outbound_calls?.uniqe_outgoing_calls
                            )} */}
                            {outboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : outboundCalls?.uniqe_outgoing_calls === null ? (
                              0
                            ) : (
                              outboundCalls?.uniqe_outgoing_calls
                            )}
                          </h3>
                          <p>Total Unique</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_calls?.unique_unanswered ===
                              null ? (
                              0
                            ) : (
                              summary?.outbound_calls?.unique_unanswered
                            )} */}
                            {outboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : outboundCalls?.unique_unanswered === null ? (
                              0
                            ) : (
                              outboundCalls?.unique_unanswered
                            )}
                          </h3>
                          <p>Total Unique Missed</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {" "}
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_calls?.connected === null ? (
                              0
                            ) : (
                              summary?.outbound_calls?.connected
                            )}
                            {summary !== undefined && "%"} */}
                            {outboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : outboundCalls?.connected === null ? (
                              0
                            ) : (
                              outboundCalls?.connected
                            )}
                            {outboundCalls !== undefined && "%"}
                          </h3>
                          <p>Connected</p>
                        </div>
                      </div>

                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_calls?.unique_connected ===
                              null ? (
                              0
                            ) : (
                              summary?.outbound_calls?.unique_connected
                            )}
                            {summary !== undefined && "%"} */}
                            {outboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : outboundCalls?.unique_connected === null ? (
                              0
                            ) : (
                              outboundCalls?.unique_connected
                            )}
                            {outboundCalls !== undefined}
                          </h3>
                          <p>Unique Connected</p>
                        </div>
                      </div>

                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>
                            {/* {summary === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : summary?.outbound_calls?.unanswered === null ? (
                              0
                            ) : (
                              summary?.outbound_calls?.unanswered
                            )} */}
                            {outboundCalls === undefined ? (
                              <div uk-spinner="" className="loader"></div>
                            ) : outboundCalls?.unanswered === null ? (
                              0
                            ) : (
                              outboundCalls?.unanswered
                            )}
                          </h3>
                          <p>Total Missed</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {(auth.vpbx_id === process.env.REACT_APP_TCS_VPBX ||
                auth.call_initiated === "1") && (
                <div className="uk-width-1-1">
                  <div className="uk-card uk-card-default uk-card-small uk-card-body">
                    <div className="head">
                      <h5 className="uk-heading-divider">Feedback</h5>
                    </div>
                    <div className="uk-container uk-container-small">
                      <div className="uk-grid uk-grid-small" uk-grid="">
                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {/* {summary === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : summary?.feedback_calls
                                  ?.total_feedback_count === null ? (
                                0
                              ) : (
                                summary?.feedback_calls?.total_feedback_count
                              )} */}
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.total_feedback_count ===
                                null ? (
                                0
                              ) : (
                                feedbackCalls?.total_feedback_count
                              )}
                            </h3>
                            <p>Total Count</p>
                          </div>
                        </div>
                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {/* {summary === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : summary?.feedback_calls
                                  ?.total_feedback_answer === null ? (
                                0
                              ) : (
                                summary?.feedback_calls?.total_feedback_answer
                              )} */}
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.total_feedback_answer ===
                                null ? (
                                0
                              ) : (
                                feedbackCalls?.total_feedback_answer
                              )}
                            </h3>
                            <p>Total Answer</p>
                          </div>
                        </div>
                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {/* {summary === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : summary?.feedback_calls
                                  ?.total_feedback_noanswer === null ? (
                                0
                              ) : (
                                summary?.feedback_calls?.total_feedback_noanswer
                              )} */}
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.total_feedback_noanswer ===
                                null ? (
                                0
                              ) : (
                                feedbackCalls?.total_feedback_noanswer
                              )}
                            </h3>
                            <p>Total Noanswer</p>
                          </div>
                        </div>

                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.connected === null ? (
                                0
                              ) : (
                                feedbackCalls?.connected + "%"
                              )}
                            </h3>
                            <p>Total Connected</p>
                          </div>
                        </div>
                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.total_talk_time === null ? (
                                0
                              ) : (
                                feedbackCalls?.total_talk_time
                              )}
                            </h3>
                            <p>Total Talk Time</p>
                          </div>
                        </div>
                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.positiveCount === null ? (
                                0
                              ) : (
                                feedbackCalls?.positiveCount
                              )}
                            </h3>
                            <p>Total Positive Count</p>
                          </div>
                        </div>
                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.negativeCount === null ? (
                                0
                              ) : (
                                feedbackCalls?.negativeCount
                              )}
                            </h3>
                            <p>Total Negative Count</p>
                          </div>
                        </div>

                        <div className="uk-width-expand">
                          <div className="overCardTxt">
                            <h3>
                              {/* {summary === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : summary?.feedback_calls
                                  ?.total_feedback_campaign === null ? (
                                0
                              ) : (
                                summary?.feedback_calls?.total_feedback_campaign
                              )} */}
                              {feedbackCalls === undefined ? (
                                <div uk-spinner="" className="loader"></div>
                              ) : feedbackCalls?.total_feedback_campaign ===
                                null ? (
                                0
                              ) : (
                                feedbackCalls?.total_feedback_campaign
                              )}
                            </h3>
                            <p>Total Campaign</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* Missed Calls vs Outbound Calls */}



              {/* INCOMING TOP AGENTS */}

              {/* <div className="uk-width-1-2">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Incoming top agents</h5>
                  </div>
                  <div className="AgentTable">
                    <table className="uk-table uk-table-striped">
                      <thead>
                        <tr>
                          <th>AGENT</th>
                          <th className="uk-width-small">CALLS</th>
                        </tr>
                      </thead>
                      <tbody>
                       
                        {topAgent.inbound === null ? (
                          <tr>
                            <td>
                              <div uk-spinner="" className="loader"></div>
                            </td>
                            <td>
                              <div uk-spinner="" className="loader"></div>
                            </td>
                          </tr>
                        ) : (
                          topAgent.inbound
                            .sort((a, b) => b.inbound_count - a.inbound_count)
                            .map((val, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <img
                                      className="uk-preserve-width uk-border-circle"
                                      src="./assets/images/zong/newavatr.png"
                                      width="24"
                                      height="24"
                                      alt=""
                                    />
                                    <span style={{ color: "#e40077" }}>
                                      {val.extension_name === null
                                        ? val.name
                                        : val.extension_name}
                                    </span>
                                  </td>
                                  <td>{val.inbound_count}</td>
                                </tr>
                              );
                            })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> */}

              {/* Entries comparison */}

              {/* OUTGOING TOP AGENTS */}

              {/* <div className="uk-width-1-2">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Outgoing top agents</h5>
                  </div>
                  <div className="AgentTable">
                    <table className="uk-table uk-table-striped">
                      <thead>
                        <tr>
                          <th>AGENT</th>
                          <th className="uk-width-small">CALLS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {topAgent.outbound === null ? (
                          <tr>
                            <td>
                              <div uk-spinner="" className="loader"></div>
                            </td>
                            <td>
                              <div uk-spinner="" className="loader"></div>
                            </td>
                          </tr>
                        ) : (
                          topAgent.outbound
                            .sort((a, b) => b.outbound_count - a.outbound_count)
                            .map((val, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <img
                                      className="uk-preserve-width uk-border-circle"
                                      src="./assets/images/zong/newavatr.png"
                                      width="24"
                                      height="24"
                                      alt=""
                                    />
                                    <span style={{ color: "#e40077" }}>
                                      {val.extension_name === null
                                        ? val.name
                                        : val.extension_name}
                                    </span>
                                  </td>
                                  <td>{val.outbound_count}</td>
                                </tr>
                              );
                            })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> */}

                        


            </div>
          </div>
        </div>
      )}

      {/* for usern only  */}
      {/* {auth.role === "3" && (
        <div className="dashboardWrp">
          <div className="uk-container uk-container-large">
            <div className="dashboardTop">
              <div uk-grid="" className="uk-grid uk-grid-small">
                <div className="uk-width-1-1">
                  <div className="dashboardIntro">
                    <h3>DASHBOARDS</h3>
                    <h4>
                      Extesnion :
                      {auth.extension_name === null
                        ? " not availble "
                        : auth.extension_name}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div
              uk-grid=""
              uk-height-match="target: div > .uk-card"
              className="uk-grid uk-grid-small"
            >
              Highlights
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5 className="uk-heading-divider">Highlights</h5>
                  </div>
                  <div className="uk-container uk-container-small">
                    <div uk-grid="">
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>{summary?.inbound_call_count}</h3>
                          <p>Inbound Calls</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>{summary?.outbound_call_count}</h3>
                          <p>Outbound Calls</p>
                        </div>
                      </div>
                      <div className="uk-width-expand">
                        <div className="overCardTxt">
                          <h3>{summary?.extension_call_count}</h3>
                          <p>Extension Calls</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              highlight end
              Call Overview
              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body">
                  <div className="head">
                    <h5>Call Overview</h5>
                  </div>
                  Chart
                  <div className="ChannelsOverviewGraph">
                    <Linechart
                      labels={graphDataAdmin?.labels}
                      data1={graphDataAdmin?.outbound}
                      data2={graphDataAdmin?.extension}
                      name1="Inbound calls"
                      name2="Extension calls"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default Dashboard;
